module.exports = __webpack_public_path__ + "img/file-vector.402631f1.svg";